module.exports = {
    raiderData: () => {
        return[
            {
            "Logo":require("./../../UI/general/Sidebar/btns-motos/raider/Raider.svg"),
            "Motos":[
                {
                    "Nombre":"Raider 125",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/raider/Raider.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/raider/Raider360.png')
                }
            ]
            }
        ]
    }
}